/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, string, bool,
} from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useMediaQuery, useTheme } from '@material-ui/core';
import ZipInput from '../../../../../EnterpriseDesignSystem/Inputs/ZipInput/ZipInput';
import Select from '../../../../../EnterpriseDesignSystem/Select/Select';
import StyledButton from '../../../../../EnterpriseDesignSystem/Button/StyledButton';
import classes from './giftFinderEdsFiveOh.module.css';

const GiftFinderFiveOhEds = ({
    data, handleSubmitEds, userSubmittedZip, handleChange, onSubmitCheck, zip, validatedZip, setSelectedOccasion, buttonStyle,
}) => {
    useStyles(classes);
    const theme = useTheme();
    const convertedGiftFinderBgColor = theme.palette?.cms?.giftfindertest_bg || '#201648';
    const fiveOhGiftFinderButtonBackgroundColor = theme.palette?.cms?.giftfindertest_button || '#F3E7F4';
    const fiveOhZipLabel = data?.gift_finder_blocks?.[0]?.delivery_zip_code?.label_2 || 'ZIP Code';
    const isMobile = useMediaQuery('(max-width: 768px)');
    const giftFinderBodyTextColor = data?.text_color || '';
    const sectionTitle = data?.title_name || '';
    const edsZipLabel = data?.gift_finder_blocks?.[0]?.delivery_zip_code?.eds_label || 'Delivery zip code';
    const occasion_option_group = data?.gift_finder_blocks?.[1]?.occasion?.occasion_option_group || [];
    const giftFinderWidth = `${classes.giftFinderEdsInnerContainer} ${data?.has_full_width && classes.giftFinderEdsInnerContainerFullWidth}`;
    const getGiftFinderWrapperClass = (has_negative_margin_top, has_full_width) => {
        const baseClass = classes.giftFinderEdsFormWrapper;
        if (has_negative_margin_top) {
            return baseClass;
        }
        const marginClassOverride = has_full_width
            ? classes.giftFinderNoMarginTop
            : classes.giftFinderNoNegativeTopMargin;

        return `${baseClass} ${marginClassOverride} ${classes.fiveOhGiftFinder}`;
    };
    const giftFinderWrapperClassName = getGiftFinderWrapperClass(data?.has_negative_margin_top, data?.has_full_width);
    const mobileButtonTitle = data?.cta_copy_2 || 'Search';
    const desktopButtonTitle = data?.cta_copy || 'Find a Gift Now';
    return (
        <form className={giftFinderWrapperClassName} onSubmit={handleSubmitEds} id="gf-eds">
            <div className={giftFinderWidth} style={{ backgroundColor: convertedGiftFinderBgColor }}>
                <div className={classes.giftFinderEdsSectionTitle} style={{ color: giftFinderBodyTextColor }}>
                    {sectionTitle || 'Find the Perfect Gift'}
                </div>
                <div className={classes.fieldContainer}>
                    <div className={classes.giftFinderEdsZipWidthContainer}>
                        <ZipInput
                            id="zipcode-native-label-placeholder"
                            dataTest="hp-zipcode-native-label-placeholder"
                            label={fiveOhZipLabel || edsZipLabel}
                            name="zipcode"
                            type="text"
                            defaultValue={userSubmittedZip}
                            value={zip}
                            handleChange={(e) => {
                                handleChange('zip')(e);
                            }}
                            onSubmitCheck={onSubmitCheck}
                        />
                        {onSubmitCheck
                        && (
                            <div className={classes.zipInputError}>
                                Enter a valid ZIP Code
                            </div>
                        )}
                    </div>
                    <div className={classes.giftFinderEdsSelectWidthContainer}>
                        <Select
                            label="Occasion"
                            id="occasion-native-label-placeholder"
                            dataTestId="4810-hp-occasion-native-label-placeholder"
                            name="occasion"
                            dropDownList={occasion_option_group}
                            handleChange={(e) => {
                                setSelectedOccasion(e.target.value);
                            }}
                        />
                    </div>
                    <div className={classes.giftFinderEdsButtonWidthContainer}>
                        <StyledButton
                            label={isMobile ? mobileButtonTitle : desktopButtonTitle}
                            variant="light"
                            size="lg"
                            type="submit"
                            attributes={{
                                style: {
                                    border: `1px solid ${ fiveOhGiftFinderButtonBackgroundColor  || '#F3E7F4'}`,
                                    backgroundColor: fiveOhGiftFinderButtonBackgroundColor || '#F3E7F4',
                                    color: buttonStyle.color,
                                    height: '56px',
                                    textTransform: 'none',
                                },
                                id: 'fagf-btn',
                                'data-test-id': 'fagf-btn',
                            }}
                        />
                    </div>
                </div>
            </div>
        </form>
    );
};

GiftFinderFiveOhEds.propTypes = {
    buttonStyle: object,
    data: object.isRequired,
    onSubmitCheck: func.isRequired,
    handleChange: func.isRequired,
    handleSubmitEds: func.isRequired,
    validatedZip: string.isRequired,
    setSelectedOccasion: func.isRequired,
    userSubmittedZip: string.isRequired,
    zip: string,
};

GiftFinderFiveOhEds.defaultProps = {
    zip: '',
    buttonStyle: {},
};

export default GiftFinderFiveOhEds;
